import { useEffect } from 'react'
import { startActivityTracker, stopActivityTracker } from '../../services/activityTracker'

// Invisible manager (like VoiceManager): runs the web activity tracker while
// mounted, so the OS itself captures active time → ingest → ClickHouse →
// reports. Mounted in App.tsx for authenticated users only (not guests).
// activityTracker is a no-op inside Electron (the native agent owns heartbeats).
export default function TrackerHeartbeat() {
  useEffect(() => {
    startActivityTracker()
    return () => stopActivityTracker()
  }, [])
  return null
}
